export default __webpack_public_path__ + "static/media/logo.22529837.png";